"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetConfigWorkingDay = void 0;
exports.isFleetConfigWorkingDay = isFleetConfigWorkingDay;
var FleetConfigWorkingDay;
(function (FleetConfigWorkingDay) {
    FleetConfigWorkingDay[FleetConfigWorkingDay["MONDAY"] = 1] = "MONDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["TUESDAY"] = 2] = "TUESDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["WEDNESDAY"] = 4] = "WEDNESDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["THURSDAY"] = 8] = "THURSDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["FRIDAY"] = 16] = "FRIDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["SATURDAY"] = 32] = "SATURDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["SUNDAY"] = 64] = "SUNDAY";
    FleetConfigWorkingDay[FleetConfigWorkingDay["HOLIDAY"] = 128] = "HOLIDAY";
})(FleetConfigWorkingDay || (exports.FleetConfigWorkingDay = FleetConfigWorkingDay = {}));
/**
 * Checks if a specific working day flag is set in the fleet configuration value.
 *
 * @param value - The numeric value representing the combined working days flags
 * @param day - The specific working day flag to check for
 * @returns `true` if the specified working day flag is set in the value, `false` otherwise
 *
 * @remarks
 * This function uses bitwise AND operation to check if a particular day flag is present
 * in the combined flags value. It's commonly used to determine if a fleet operates on
 * a specific day of the week.
 */
function isFleetConfigWorkingDay(value, day) {
    return (value & day) !== 0;
}
//# sourceMappingURL=fleet-config.js.map